import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { LoadingSpinner } from "../AuthPage";

const ResetPassword = () => {
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(true);
  const [isVerified, setIsVerified] = useState(false);
  const [userId, setUserId] = useState("");
  const [resetToken, setResetToken] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();
  // Extract query parameters
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const userId = params.get("userId");
    const resetToken = params.get("resetToken");
    if (userId && resetToken) {
      setUserId(userId);
      setResetToken(resetToken);
      verifyResetToken(userId, resetToken);
    } else {
      setMsg("Ungültige Anfrage");
      setIsLoading(false);
    }
  }, [location.search]);

  const verifyResetToken = async (userId, resetToken) => {
    try {
      const response = await axios.post(
        "https://dealersonly.parts/beta/api/verifyReset",
        {
          userId,
          resetToken,
        }
      );
      if (response.status === 200) {
        setIsVerified(true);
      } else {
        setMsg(response.data);
        setTimeout(() => {
          navigate("/login");
        }, 2000); // Redirect after 1 second
      }
    } catch (error) {
      setMsg(
        error.response ? error.response.data : "Fehler bei der Verifizierung"
      );
      setTimeout(() => {
        navigate("/login");
      }, 2000); // Redirect after 1 second
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMsg("Passwörter stimmen nicht überein");
      return;
    }
    try {
      const response = await axios.post(
        "https://dealersonly.parts/beta/api/changePassword",
        {
          userId,

          password,
        }
      );
      if (response.status === 200) {
        setMsg("Passwort geändert, Weiterleitung zur Anmeldung...");
        setTimeout(() => {
          navigate("/login");
        }, 2000); // Redirect after 1 second
      } else {
        setMsg(response.data);
      }
    } catch (error) {
      setMsg(
        error.response
          ? error.response.data
          : "Fehler beim Ändern des Passworts"
      );
    }
  };

  return (
    <div className="flex min-h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8">
        <div>
          <img
            className="mx-auto h-24 w-auto"
            src="https://dealersonly.parts/beta/app/files/abujo.jpg"
            alt="D.O.P.E by Abujo Trading"
          />
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
            Passwort zurücksetzen
          </h2>
        </div>
        {isLoading ? (
          <div className="flex justify-center items-center">
            <LoadingSpinner />
            <span className="ml-2">Verifizierung läuft...</span>
          </div>
        ) : isVerified ? (
          <form className="mt-8 space-y-6" onSubmit={handleChangePassword}>
            <div className="-space-y-px rounded-md shadow-sm">
              <div>
                <label htmlFor="password" className="sr-only">
                  Neues Passwort
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="new-password"
                  required
                  className="relative block w-full appearance-none rounded-none rounded-t-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  placeholder="Neues Passwort"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="confirm-password" className="sr-only">
                  Passwort bestätigen
                </label>
                <input
                  id="confirm-password"
                  name="confirmPassword"
                  type="password"
                  autoComplete="new-password"
                  required
                  className="relative block w-full appearance-none rounded-none rounded-b-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  placeholder="Passwort bestätigen"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
            </div>
            {msg && (
              <div className="rounded-md bg-yellow-50 p-4 mb-1">
                <div className="flex">
                  <div className="ml-3">
                    <h3 className="text-sm font-medium text-yellow-800">
                      {msg}
                    </h3>
                  </div>
                </div>
              </div>
            )}
            <div>
              <button
                type="submit"
                className="group relative flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                Passwort ändern
              </button>
            </div>
          </form>
        ) : (
          <div className="rounded-md bg-yellow-50 p-4 mb-1">
            <div className="flex">
              <div className="ml-3">
                <h3 className="text-sm font-medium text-yellow-800">{msg}</h3>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
